import { GIFT_LOCAL_STORAGE_KEY } from 'modules/gift/constants'
import setItemLocalStorageUtil from 'utils/local-storage/set-item'
import removeItemLocalStorageUtil from 'utils/local-storage/remove-item'

export default function updateGiftingModeGiftUtil (value) {
  const key = GIFT_LOCAL_STORAGE_KEY.GIFTING_MODE
  if (value) {
    setItemLocalStorageUtil(key, value)
    return
  }
  removeItemLocalStorageUtil(key)
}
